import React from 'react';
import { Link } from 'react-router-dom';
import './WithdrawalConfirm.css';

const WithdrawalConfirm: React.FC = () => {
  const mockWithdrawal = {
    amount: '10',
    currency: 'USDT',
    usdValue: '$10.00',
    network: 'ERC20',
    address: '0x19b4fd8f1f3acf094361abf777acd840ab8e1d47',
    networkFee: '0.0001',
    receiveAmount: '9.9999'
  };

  const handleCopyAddress = () => {
    navigator.clipboard.writeText(mockWithdrawal.address);
  };

  return (
    <div className="app-container">
      <div className="mobile-frame">
        <div className="mobile-notch"></div>
        <div className="mobile-screen">
          <div className="withdrawal-confirm">
            <div className="withdrawal-confirm-header">
              <Link to="/withdraw" className="withdrawal-confirm-back">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Link>
              <h1 className="withdrawal-confirm-title">Confirm Withdrawal</h1>
            </div>

            <div className="withdrawal-confirm-content">
              <div className="withdrawal-confirm-amount-card">
                <div className="withdrawal-confirm-amount-label">You will send</div>
                <div className="withdrawal-confirm-amount-value">
                  <span className="withdrawal-confirm-amount-number">{mockWithdrawal.amount}</span>
                  <span className="withdrawal-confirm-amount-currency">{mockWithdrawal.currency}</span>
                </div>
                <div className="withdrawal-confirm-amount-usd">≈ {mockWithdrawal.usdValue} USD</div>
              </div>

              <div className="withdrawal-confirm-details-card">
                <h3 className="withdrawal-confirm-details-heading">Transaction Details</h3>

                <div className="withdrawal-confirm-detail-group">
                  <div className="withdrawal-confirm-detail-label">Network</div>
                  <div className="withdrawal-confirm-detail-value">{mockWithdrawal.network}</div>
                </div>

                <div className="withdrawal-confirm-detail-group">
                  <div className="withdrawal-confirm-detail-label">Withdrawal Address</div>
                  <div className="withdrawal-confirm-address-box">
                    <span className="withdrawal-confirm-address-text">{mockWithdrawal.address}</span>
                    <button 
                      className="withdrawal-confirm-copy-btn" 
                      onClick={handleCopyAddress}
                      aria-label="Copy address"
                    >
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <rect x="5" y="5" width="9" height="9" rx="1" stroke="currentColor" strokeWidth="1.5"/>
                        <path d="M3 10.5V3C3 2.44772 3.44772 2 4 2H10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                      </svg>
                    </button>
                  </div>
                </div>

                <div className="withdrawal-confirm-divider"></div>

                <div className="withdrawal-confirm-summary-row">
                  <span className="withdrawal-confirm-summary-label">Amount</span>
                  <span className="withdrawal-confirm-summary-value">{mockWithdrawal.amount} {mockWithdrawal.currency}</span>
                </div>

                <div className="withdrawal-confirm-summary-row">
                  <span className="withdrawal-confirm-summary-label">Network Fee</span>
                  <span className="withdrawal-confirm-summary-value">{mockWithdrawal.networkFee} {mockWithdrawal.currency}</span>
                </div>

                <div className="withdrawal-confirm-divider"></div>

                <div className="withdrawal-confirm-total-row">
                  <span className="withdrawal-confirm-total-label">You will receive</span>
                  <span className="withdrawal-confirm-total-value">{mockWithdrawal.receiveAmount} {mockWithdrawal.currency}</span>
                </div>
              </div>

              <div className="withdrawal-confirm-notice">
                <div className="withdrawal-confirm-notice-title">⚠️ Important Notice</div>
                <div className="withdrawal-confirm-notice-text">
                  Please verify all details carefully. Cryptocurrency transactions cannot be reversed.
                </div>
              </div>

              <Link to="/withdrawal-verify" className="withdrawal-confirm-btn-primary">
                Confirm Withdrawal
              </Link>

              <Link to="/withdraw" className="withdrawal-confirm-btn-secondary">
                Cancel
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithdrawalConfirm;
